import styled from "styled-components";
import { CHART_TOOLTIP_MARKER_SIZE } from "@resources/Constants";

interface TooltipStyledProps {
  width?: string;
}

export const TooltipStyled = styled.div<TooltipStyledProps>`
  width: ${({ width }) => width};
  padding: 6px 8px;
  background: var(--surface-modal);
  border-radius: 4px;

  .subject-wrapper {
    font-size: 12px;
    line-height: 16px;
    color: var(--text-primary);

    div:first-of-type {
      font-weight: 700;
    }

    .subject {
      display: flex;
      gap: 4px;
      align-items: center;
    }
  }

  .info-wrapper {
    font-size: 10px;
    line-height: 14px;
    color: var(--text-primary);

    .info {
      display: flex;
      justify-content: space-between;

      &-name {
        display: flex;
        margin-right: 10px;

        .marker {
          width: ${CHART_TOOLTIP_MARKER_SIZE};
          height: ${CHART_TOOLTIP_MARKER_SIZE};
          border-radius: 100%;
          background-color: red;
          margin: auto 4px auto 0;
        }
      }

      &-value {
        display: flex;

        &-percent {
          width: 32px;
          margin-left: 2px;
          text-align: end;
        }
      }
    }
  }
`;
